export default __webpack_public_path__ + "static/media/dashboard-preview.87c5740a.png";